import { render } from "./MyPlaylist.vue?vue&type=template&id=12edd8f0&scoped=true"
import script from "./MyPlaylist.vue?vue&type=script&lang=js"
export * from "./MyPlaylist.vue?vue&type=script&lang=js"

import "./MyPlaylist.vue?vue&type=style&index=0&id=12edd8f0&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\music_player\\music_player_sj\\music_player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12edd8f0"]])

export default __exports__